import { ReactComponent as Logo } from "@/assets/dinamo-logo.svg";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import "./PageNotFound.css";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="not-found-container">
      <Logo className="background-logo" />
      <div className="not-found-content ">
        <div className="flex flex-col text-center">
          <div className="not-found-title">404</div>
        </div>
        <div className="not-found-description">
          <div className="text-[2rem] font-bold">
            Stranica koju tražite ne postoji.
          </div>
          <div className="text-[1.075rem]">
            Provjerite upisanu web adresu ili se vratite na početni ekran.
          </div>
          <div className="flex justify-center">
            <Button
              variant="filled"
              color="#004a99"
              radius="xl"
              size="md"
              className="!h-[3rem]"
              onClick={() => navigate("/")}
            >
              Natrag na početnu
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
